const CURRENCY_BY_COUNTRY = {
  // eslint-disable-next-line quote-props
  'en_US': 'US$',
  // eslint-disable-next-line quote-props
  'es': '€',
  // eslint-disable-next-line quote-props
  'pt_BR': 'R$'
}

const TEXT_FORMATTING_TYPE = {
  DEFAULT: 0,
  DATE: 1,
  CURRENCY: 2,
  PERCENT: 3,
  KG: 4,
  TON: 5,
  M2: 6,
  M3: 7,
  LITRO: 8
}

const CARD_SELECT_TYPES = {
  MONTHS: 0,
  YEARS: 1,
  OTHER: 2
}

export {
  CARD_SELECT_TYPES,
  CURRENCY_BY_COUNTRY,
  TEXT_FORMATTING_TYPE
}
